import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M.25 4.457h4.1v-4.1H.25v4.1zM7.875 4.48h4.102V.38H7.875v4.1zM.273 12.08h4.101v-4.1h-4.1v4.1zM7.875 12.113h4.102v-4.1H7.875v4.1z" stroke="#fff" stroke-width=".5"/></svg>`;

export { symbol as default };
